export default __webpack_public_path__ + "static/media/0xee9a352f6aac4af1a5b9f467f6a93e0ffbe9dd35.41f9506c.webp";